import D1 from '../../components/ExcerciseTypes/Design/TypeIn';
import Circle_Write from '../../components/ExcerciseTypes/Circle_Write';



const json = {

  1: { // Exercise num
    unit: 'Review 2',
    id: 'SB4-PV2-P48-E1',
    audio: '',
    video: '',
    component: D1,
    textAlign: 'center',
    maxLength: 1,
    padding: '5px 0 0 0',
    exerciseKey: 'img/FriendsPlus/Page48/E1/Key/answerKey.png',
    fontSize: 20,
    questionImage: [ // Row
      [
        // Column1
        { url: 'img/FriendsPlus/Page48/E1/1.jpg' },
      ],
      [
        // Column2
        { url: 'img/FriendsPlus/Page48/E1/2.jpg' },
        { url: 'img/FriendsPlus/Page48/E1/3.jpg', input: true, answer: "c" },
        { url: 'img/FriendsPlus/Page48/E1/4.jpg', input: true, answer: "a" },
        { url: 'img/FriendsPlus/Page48/E1/5.jpg', input: true, answer: "r" },
        { url: 'img/FriendsPlus/Page48/E1/6.jpg' },
        { url: 'img/FriendsPlus/Page48/E1/7.jpg', input: true, answer: "d" },
        { url: 'img/FriendsPlus/Page48/E1/8.jpg' },
      ],
      [
        // Column3
        { url: 'img/FriendsPlus/Page48/E1/9.jpg' },
        { url: 'img/FriendsPlus/Page48/E1/10.jpg', input: true, answer: "o" },
        { url: 'img/FriendsPlus/Page48/E1/11.jpg' },
      ],
      [
        // Column4
        { url: 'img/FriendsPlus/Page48/E1/12.jpg' },
        { url: 'img/FriendsPlus/Page48/E1/13.jpg', input: true, answer: "n" },
        { url: 'img/FriendsPlus/Page48/E1/14.jpg', input: true, answer: "o" },
        { url: 'img/FriendsPlus/Page48/E1/15.jpg', input: true, answer: "r" },
        { url: 'img/FriendsPlus/Page48/E1/16.jpg' },
        { url: 'img/FriendsPlus/Page48/E1/17.jpg', input: true, answer: "e" },
        { url: 'img/FriendsPlus/Page48/E1/18.jpg', input: true, answer: "l" },
        { url: 'img/FriendsPlus/Page48/E1/19.jpg', input: true, answer: "i" },
        { url: 'img/FriendsPlus/Page48/E1/20.jpg', input: true, answer: "n" },
        { url: 'img/FriendsPlus/Page48/E1/21.jpg' },
      ],
      [
        // Column5
        { url: 'img/FriendsPlus/Page48/E1/22.jpg' },
        { url: 'img/FriendsPlus/Page48/E1/23.jpg', input: true, answer: "k" },
        { url: 'img/FriendsPlus/Page48/E1/24.jpg' },
        { url: 'img/FriendsPlus/Page48/E1/25.jpg', input: true, answer: "e" },
        { url: 'img/FriendsPlus/Page48/E1/26.jpg' },
      ],
      [
        // Column6
        { url: 'img/FriendsPlus/Page48/E1/27.jpg' },
        { url: 'img/FriendsPlus/Page48/E1/28.jpg', input: true, answer: "e" },
        { url: 'img/FriendsPlus/Page48/E1/29.jpg' },
        { url: 'img/FriendsPlus/Page48/E1/30.jpg', input: true, answer: "e" },
        { url: 'img/FriendsPlus/Page48/E1/31.jpg' },
      ],
      [
        // Column7
        { url: 'img/FriendsPlus/Page48/E1/32.jpg' },
        { url: 'img/FriendsPlus/Page48/E1/33.jpg', input: true, answer: "y" },
        { url: 'img/FriendsPlus/Page48/E1/34.jpg' },
        { url: 'img/FriendsPlus/Page48/E1/35.jpg', input: true, answer: "u" },
        { url: 'img/FriendsPlus/Page48/E1/36.jpg', input: true, answer: "r" },
        { url: 'img/FriendsPlus/Page48/E1/37.jpg' },
        { url: 'img/FriendsPlus/Page48/E1/38.jpg', input: true, answer: "i" },
        { url: 'img/FriendsPlus/Page48/E1/39.jpg' },
        { url: 'img/FriendsPlus/Page48/E1/40.jpg', input: true, answer: "g" },
        { url: 'img/FriendsPlus/Page48/E1/41.jpg' },
      ],
      [
        // Column8
        { url: 'img/FriendsPlus/Page48/E1/42.jpg' },
        { url: 'img/FriendsPlus/Page48/E1/43.jpg', input: true, answer: "u" },
        { url: 'img/FriendsPlus/Page48/E1/44.jpg' },
      ],
      [
        // Column9
        { url: 'img/FriendsPlus/Page48/E1/45.jpg' },
        { url: 'img/FriendsPlus/Page48/E1/46.jpg', input: true, answer: "n" },
        { url: 'img/FriendsPlus/Page48/E1/47.jpg' },
      ],
      [
        // Column10
        { url: 'img/FriendsPlus/Page48/E1/48.jpg' },
        { url: 'img/FriendsPlus/Page48/E1/49.jpg', input: true, answer: "a" },
        { url: 'img/FriendsPlus/Page48/E1/50.jpg', input: true, answer: "i" },
        { url: 'img/FriendsPlus/Page48/E1/51.jpg', input: true, answer: "l" },
        { url: 'img/FriendsPlus/Page48/E1/52.jpg', input: true, answer: "i" },
        { url: 'img/FriendsPlus/Page48/E1/53.jpg' },
        { url: 'img/FriendsPlus/Page48/E1/54.jpg', input: true, answer: "g" },
        { url: 'img/FriendsPlus/Page48/E1/55.jpg' },
      ],
      [
        // Column11
        { url: 'img/FriendsPlus/Page48/E1/56.jpg' },
        { url: 'img/FriendsPlus/Page48/E1/57.jpg', input: true, answer: "y" },
        { url: 'img/FriendsPlus/Page48/E1/58.jpg' },
      ],
      [
        // Column12
        { url: 'img/FriendsPlus/Page48/E1/59.jpg' },
      ],


    ],
  },
  2: { // Exercise num
    unit: 'Review 2',
    id: 'SB4-PV2-P48-E2',
    audio: '',
    video: '',
    padding: 0,
    component: D1,
    fontSize: 22,
    exerciseKey: 'img/FriendsPlus/Page48/E2/Key/answerKey.png',
    questionImage: [ // Row
      [
        // Column1
        { url: 'img/FriendsPlus/Page48/E2/1.jpg' },
      ],
      [
        // Column2
        { url: 'img/FriendsPlus/Page48/E2/2.jpg' },
        { url: 'img/FriendsPlus/Page48/E2/3.jpg', input: true, answer: "crocodile " },
        { url: 'img/FriendsPlus/Page48/E2/4.jpg' },
      ],
      [
        // Column3
        { url: 'img/FriendsPlus/Page48/E2/5.jpg' },
      ],
      [
        // Column4
        { url: 'img/FriendsPlus/Page48/E2/6.jpg' },
        { url: 'img/FriendsPlus/Page48/E2/7.jpg', input: true, answer: "kangaroo" },
        { url: 'img/FriendsPlus/Page48/E2/8.jpg' },
      ],
      [
        // Column5
        { url: 'img/FriendsPlus/Page48/E2/9.jpg' },
        { url: 'img/FriendsPlus/Page48/E2/10.jpg', input: true, answer: "zebra" },
        { url: 'img/FriendsPlus/Page48/E2/11.jpg' },
      ],
      [
        // Column6
        { url: 'img/FriendsPlus/Page48/E2/12.jpg' },
        { url: 'img/FriendsPlus/Page48/E2/13.jpg', input: true, answer: "camel" },
        { url: 'img/FriendsPlus/Page48/E2/14.jpg' },
      ],
      [
        // Column7
        { url: 'img/FriendsPlus/Page48/E2/15.jpg' },
      ],


    ],
  },
  3: { // Exercise num
    unit: 'Review 2',
    id: 'SB4-PV2-P48-E3',
    audio: '',
    video: '',
    recorder: false,
    component: Circle_Write,
    exerciseKey: 'img/FriendsPlus/Page48/E3/Key/answerKey.png',
    // titleQuestion: [{ num: '32', title: 'Read the chant again. Circle the words with ow and ou.', color: "#5B5A5D" }],
    question: {
      Write: {
        inputStyle: {},
        answers: [],
        initialValue: [],
      },
      Circle: {
        // initialWordStyle: { margin: '5px 0', border: 'solid 2px', borderColor: 'black', borderRadius: '50%', padding: '0 5px' },
        initialWordStyle: { margin: '5px 0', border: 'none', borderColor: 'transparent', borderRadius: '50%' },
        selectWordStyle: { border: 'solid 2px', borderColor: '#00a8ec', margin: '-2px' },
        limitSelect: 1,
        listWords: [
          'are / aren\'t ',//2
          'are / aren\'t ',//3
          'is / isn\'t ',//4
          'is / isn\'t ',//5
          'are / aren\'t ',//6

        ],
        answers: ['0-0', '1-0', '2-4', '3-0', '4-4'],
        initialValue: [],
      },
      Layout: `
        <div style='width: 1100px;'>
            <div>
              <img src="img/FriendsPlus/Page48/E3/1.jpg" style="width: 100%" />
            </div>
            <div style='position: absolute;top: 10%;'>
              <div style='margin-left: 30px;letter-spacing: 0px;'>
                  <div>
                    <b>1</b> 
                    Dad <b>is/<span style="border: 2px solid rgb(0, 168, 236);padding: 3px;border-radius: 50%;">   isn't</span>  </b>
                    reading a book.
                  </div>
                   <div> <b> 2 </b> The girls <b> <input id='0' type='Circle' /></b>  listening to music.</div>
                   <div> <b> 3 </b> The boys  <b> <input id='1' type='Circle' /></b>  playing chess.</div>
                   <div> <b> 4 </b> Mom <b> <input id='2' type='Circle' /></b>  watching TV.</div>
                   <div> <b> 5 </b> Dad <b> <input id='3' type='Circle' /></b>  eating an apple.</div>
                   <div> <b> 6 </b> The boys <b> <input id='4' type='Circle' /></b>  listening to mucsic.</div>
              </div>
            </div>
          
        </div>
      `,
    },
  },


}
export default json;
